module.exports = __webpack_public_path__ + "uefa-logo-4d7cf96ce30de34f092cc2dfdd138ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/uefa-logo.jpg
// module id = 1380
// module chunks = 1